import { BatteryCharging, BatteryFull, BatteryLow, BatteryMedium } from 'lucide-react';

const LOW_BATTERY_THRESHOLD = 20;
const FULL_BATTERY_THRESHOLD = 70;

export function RobotBatteryIndicator({ level, charging }: { level?: number; charging?: boolean }) {
  if (level === undefined) return null;
  const isLow = !charging && level <= LOW_BATTERY_THRESHOLD;
  const Icon = charging
    ? BatteryCharging
    : level > FULL_BATTERY_THRESHOLD
      ? BatteryFull
      : level > LOW_BATTERY_THRESHOLD
        ? BatteryMedium
        : BatteryLow;
  return (
    <span
      className={`robot-battery${charging ? ' robot-battery--charging' : ''}${isLow ? ' robot-battery--low' : ''}`}
      title={charging ? '充電中' : 'バッテリー残量'}
    >
      <Icon size={13} aria-hidden="true" />
      {level}%
      {charging && <span className="sr-only">（充電中）</span>}
    </span>
  );
}
